import { BonusResponse } from '@cgs/data-access';

export class BonusFinishedArgs {
  constructor(
    public response: BonusResponse | null,
    public lastSelectedValue: number | null,
    public lastSelectedView: string | null,
    public lastSelectedType: string | null,
    public totalWin: number | null,
    public bonusWin: number | null
  ) {}

  static empty(): BonusFinishedArgs {
    return new BonusFinishedArgs(null, null, null, null, null, null);
  }
}
